import StatisticsManagement from '@/vuepage/statistics/index';
import StatisticsOrder from '../vuepage/statistics/order';
import StatisticsIncome from '../vuepage/statistics/income';
import StatisticsStay from '../vuepage/statistics/stay';
import StatisticsBrowse from '../vuepage/statistics/browse';
import StatisticsShopCart from '../vuepage/statistics/shop-cart';

export default [
  {
    path: '/statistics-management',
    component: StatisticsManagement,
    children: [
      {
        path: 'order',
        component: StatisticsOrder,
        meta: [
          {
            name: '数据统计',
            url: '/statistics-management',
          },
          {
            name: '订单统计',
            url: 'order',
          },
        ],
      },
      {
        path: 'income',
        component: StatisticsIncome,
        meta: [
          {
            name: '数据统计',
            url: '/statistics-management',
          },
          {
            name: '收入统计',
            url: 'income',
          },
        ],
      },
      {
        path: 'stay',
        component: StatisticsStay,
        meta: [
          {
            name: '数据统计',
            url: '/statistics-management',
          },
          {
            name: '停留数据',
            url: 'stay',
          },
        ],
      },
      {
        path: 'browse',
        component: StatisticsBrowse,
        meta: [
          {
            name: '数据统计',
            url: '/statistics-management',
          },
          {
            name: '浏览数据',
            url: 'browse',
          },
        ],
      },
      {
        path: 'shop-cart',
        component: StatisticsShopCart,
        meta: [
          {
            name: '数据统计',
            url: '/statistics-management',
          },
          {
            name: '加入购物车数据',
            url: 'shop-cart',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/statistics.js